import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from '@chilecompra/react-kit/components'
import {
  AccordionInfoBarDetails,
  Action,
  ActionItem,
  ActionCircle,
  ActionText,
  Close,
  CloseIcon,
  Collapse,
  DownloadIcon,
  DropDownIcon,
  GridContainer,
  GridContainerFooter,
  GridItem,
  ExclamationIcon,
  ImageIcon,
  Info,
  InfoCircle,
  InfoText,
  QuestionIcon
} from '../Infobar/Infobar.styles'

/**
 * The Infobar' component.
 */
const Infobar = ({
  disableDownloadChart,
  disableDownloadCsv,
  disableInfographic,
  expandArrow,
  infographic,
  latestUpdate,
  marginFooter,
  setExpandArrow,
  onCaptureImage,
  onDownloadFile,
  paddingFooter
}) => {
  const convertToImg = () => {
    onCaptureImage && onCaptureImage()
  }

  const downloadCsv = () => {
    onDownloadFile && onDownloadFile()
  }

  const openAccordion = () => {
    setExpandArrow(!expandArrow)
  }

  const closeAcoordion = () => {
    setExpandArrow(false)
  }

  return (
    <>
      <GridContainerFooter alignItems="center" margin={marginFooter} padding={paddingFooter} spacing={1}>
        <GridItem md={5} xs={12}>
          {latestUpdate && (
            <Info>
              <InfoText>Última actualización: {latestUpdate}</InfoText>
              <Tooltip
                content="Datos actualizados con un mes de desfase ya que se extraen desde el Datawarehouse el cual se procesa y depura de forma mensual."
                placement="top"
              >
                <InfoCircle>
                  <ExclamationIcon />
                </InfoCircle>
              </Tooltip>
            </Info>
          )}
        </GridItem>
        <GridItem md={3} xs={12}>
          <Action>
            <ActionItem disabled={disableInfographic} onClick={openAccordion}>
              <ActionCircle disabled={disableInfographic}>
                <QuestionIcon />
              </ActionCircle>
              <ActionText>Aprende a leer el gráfico</ActionText>
              <DropDownIcon open={expandArrow} />
            </ActionItem>
          </Action>
        </GridItem>
        <GridItem md={2} xs={12}>
          <Action>
            <ActionItem disabled={disableDownloadChart} onClick={convertToImg}>
              <ActionCircle disabled={disableDownloadChart}>
                <ImageIcon />
              </ActionCircle>
              <ActionText>Guardar imagen</ActionText>
            </ActionItem>
          </Action>
        </GridItem>
        <GridItem md={2} xs={12}>
          <Action>
            <ActionItem disabled={disableDownloadCsv} onClick={downloadCsv}>
              <ActionCircle disabled={disableDownloadCsv}>
                <DownloadIcon />
              </ActionCircle>
              <ActionText>Descargar datos</ActionText>
            </ActionItem>
          </Action>
        </GridItem>
      </GridContainerFooter>
      {infographic && (
        <GridContainer margin="16px 0 0">
          <GridItem xs={12}>
            <Collapse unmountOnExit in={expandArrow} timeout="auto">
              <GridContainer padding="0 0 8px">
                <GridItem align="right" xs={12}>
                  <Close onClick={closeAcoordion}>
                    <CloseIcon />
                    Cerrar
                  </Close>
                </GridItem>
              </GridContainer>
              <AccordionInfoBarDetails>{infographic}</AccordionInfoBarDetails>
            </Collapse>
          </GridItem>
        </GridContainer>
      )}
    </>
  )
}

Infobar.defaultProps = {
  disableDownloadChart: false,
  disableDownloadCsv: false,
  disableInfographic: false,
  infografic: undefined,
  updatedDate: null,
  marginFooter: '5px 0 0',
  paddingFooter: '24px',
  onCaptureImage: () => undefined,
  onDownloadFile: () => undefined
}

Infobar.propTypes = {
  infographic: PropTypes.node,
  disableDownloadChart: PropTypes.bool,
  disableDownloadCsv: PropTypes.bool,
  disableInfographic: PropTypes.bool,
  expandArrow: PropTypes.bool,
  latestUpdate: PropTypes.string,
  setExpandArrow: PropTypes.func,
  marginFooter: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  paddingFooter: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onCaptureImage: PropTypes.func,
  onDownloadFile: PropTypes.func
}

export default Infobar
